module.exports = __webpack_public_path__ + "img/subject.dedb6cc9.jpg";